import { useEffect } from "react";

const BASE_TITLE = "USDD Academy";
const BASE_DESC =
  "USDD Academy — UK urban dance and creative performance academy across London & Kent. Weekly training, workshops, kids classes, events, online courses and bespoke programmes.";

export function usePageMeta(title, description) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title ? `${title} — ${BASE_TITLE}` : BASE_TITLE;

    const desc = description || BASE_DESC;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    const prevDesc = meta.getAttribute("content");
    meta.setAttribute("content", desc);

    // scroll to top on page change
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });

    return () => {
      document.title = prevTitle;
      if (prevDesc) meta.setAttribute("content", prevDesc);
    };
  }, [title, description]);
}
